import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { FLAGSHIPS, pickFlagship } from './FlagshipCard';
import { useT } from '../i18n';

const ORDER = ['indexai', 'workforce', 'catering'];

/* Elegant end-of-page secondary navigation. Never a dead end:
   ← previous platform · next platform → · Compare all → /pricing */
export default function ContinueExploring({ context, className = '', dark = false }) {
  const { lang } = useT();
  const isEs = lang === 'es';
  const { pathname } = useLocation();
  if (pathname === '/pricing') return null;

  const currentId =
    ORDER.find((id) => FLAGSHIPS[id].href === pathname) || pickFlagship(context || pathname);
  const idx = ORDER.indexOf(currentId);
  const prev = FLAGSHIPS[ORDER[(idx + ORDER.length - 1) % ORDER.length]];
  const next = FLAGSHIPS[ORDER[(idx + 1) % ORDER.length]];

  return (
    <section className={`py-12 lg:py-14 ${className}`} data-testid="continue-exploring">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-10">
        <div className="border-t border-neutral-200 pt-10">
          <p className="text-center text-[10.5px] font-semibold uppercase tracking-[0.22em] text-neutral-400">
            {isEs ? 'Sigue explorando' : 'Continue exploring'}
          </p>
          <div className="mt-6 flex items-center justify-between gap-4">
            <Link
              to={prev.href}
              className="group flex items-center gap-3 min-w-0 text-left"
              data-testid="ce-prev"
            >
              <ArrowLeft className="w-4 h-4 text-neutral-400 group-hover:text-[#F77F11] group-hover:-translate-x-0.5 transition-all shrink-0" />
              <span className="min-w-0">
                <span className="block text-[11px] text-neutral-400">{isEs ? 'Plataforma anterior' : 'Previous platform'}</span>
                <span className={`block font-semibold ${dark ? "text-neutral-200" : "text-neutral-900"} group-hover:text-[#F77F11] transition-colors text-[15px] truncate`}>{prev.name}</span>
              </span>
            </Link>
            <Link
              to={next.href}
              className="group flex items-center gap-3 min-w-0 text-right"
              data-testid="ce-next"
            >
              <span className="min-w-0">
                <span className="block text-[11px] text-neutral-400">{isEs ? 'Siguiente plataforma' : 'Next platform'}</span>
                <span className={`block font-semibold ${dark ? "text-neutral-200" : "text-neutral-900"} group-hover:text-[#F77F11] transition-colors text-[15px] truncate`}>{next.name}</span>
              </span>
              <ArrowRight className="w-4 h-4 text-neutral-400 group-hover:text-[#F77F11] group-hover:translate-x-0.5 transition-all shrink-0" />
            </Link>
          </div>
          <div className="mt-8 text-center">
            <p className="text-[13.5px] text-neutral-500">
              {isEs ? '¿Curioso por los precios?' : 'Curious about pricing?'}
            </p>
            <Link
              to="/pricing"
              className={`mt-2 inline-flex items-center gap-1.5 font-semibold text-[15px] ${dark ? "text-neutral-200" : "text-neutral-900"} hover:text-[#F77F11] transition-colors underline decoration-[#F77F11]/40 underline-offset-4 hover:decoration-[#F77F11]`}
              data-testid="ce-compare"
            >
              {isEs ? 'Compara todas las plataformas gestionadas' : 'Compare all managed platforms'}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
